import axios from 'axios';
import { Starvation } from 'views/order-feed/features/starvation/types/starvation.type';
import { FishGroup } from '../types/fish-group.type';

// GET
// /ewosapi/v1/starving-period/{globalCompanyId}/{starvingPeriodId}
export const getStarvingPeriodById = async (globalCompanyId: string, starvingPeriodId: string): Promise<Starvation> => {
  const res = await axios.get<Starvation>(`/ewosapi/v1/starving-period/${globalCompanyId}/${starvingPeriodId}`);
  return res.data;
};

//TODO should this be general? used in Planning and Prognosis and Timeline
// GET
// /ewosapi/v1/starving-period/{globalCompanyId}/active
export const getStarvingPeriodActive = async (globalCompanyId: string): Promise<Starvation[]> => {
  const res = await axios.get<Starvation[]>(`/ewosapi/v1/starving-period/${globalCompanyId}/active`);
  return res.data;
  // return StarvationPeriodData;
};

// GET
// /ewosapi/v1/starving-period/{globalCompanyId}/historic
export const getStarvingPeriodHistoric = async (globalCompanyId: string): Promise<Starvation[]> => {
  const res = await axios.get<Starvation[]>(`/ewosapi/v1/starving-period/${globalCompanyId}/historic`);
  return res.data;
};

// GET
// /ewosapi/v1/starving-period/fishgroups/{globalCompanyId}
export const getStarvingPeriodFishGroup = async (globalCompanyId: string): Promise<FishGroup[]> => {
  const res = await axios.get<FishGroup[]>(`/ewosapi/v1/starving-period/fishgroups/${globalCompanyId}`);
  return res.data;
};
